module.exports = __webpack_public_path__ + "media/assets/services_manager/app-store-5914f62197fa3a00ad4923941b3b8879128cbcc67e34063005b089488325fe45.svg";